import { IGoal } from "motw_core/Entity/IGoal";
import * as React from "react";
import { HandlePostingDailyGoalAsync } from "source/app/presentation/MainPanel/Goals/DailyGoals/DailyGoal/HandlePostingDailyGoalAsync";
import { TouchActionButton } from "source/app/presentation/Shared/TouchActionButton/TouchActionButton";
import * as styles from "./DailyGoal.css";

export function PostDailyGoalLink({
    goal,
    streakMomentum,
}: {
    goal: IGoal;
    streakMomentum?: number;
}) {
    const [shouldDisplay, setShouldDIsplay] = React.useState(true);

    if (streakMomentum && streakMomentum > 0) {
        return null;
    }

    if (!shouldDisplay) {
        return null;
    }

    return (
        <TouchActionButton
            className={styles.postDailyGoalLink}
            title="Post daily goal"
            activateOnPointerUp={true}
            onActivate={async () => {
                setShouldDIsplay(false);
                await HandlePostingDailyGoalAsync(goal);
            }}
        >
            <span className={styles.postDailyGoalGlyph}>+</span>
        </TouchActionButton>
    );
}
